import '../../../../assets/css/screens/serviceprovider/dashboard/myearnings/MyEarnings.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';

import React, { useState } from "react";
import {
  MdTrendingUp,
  MdReceipt,
  MdAccountBalanceWallet,
  MdArrowDownward,
  MdArrowUpward,
} from "react-icons/md";
// MdAccountBalanceWallet kept for stats row
import { ArrowLeft, Calendar, TrendingUp } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { useContext } from "react";
import AppContext from "../../../../context/AppContext";

// ===================== DATA =====================
const transactions = [
  // { id: 1, title: "Kitchen Plumbing Repair", date: "Mar 28, 2026", amount: +35, type: "credit" },
  // { id: 2, title: "Commission Deducted (15%)", date: "Mar 28, 2026", amount: -6, type: "debit" },
  // { id: 3, title: "Electrical Wiring Fix", date: "Mar 25, 2026", amount: +40, type: "credit" },
  // { id: 4, title: "Commission Deducted (15%)", date: "Mar 25, 2026", amount: -7, type: "debit" },
  // { id: 5, title: "AC Installation Job", date: "Mar 22, 2026", amount: +70, type: "credit" },
  // { id: 6, title: "Commission Deducted (15%)", date: "Mar 22, 2026", amount: -11, type: "debit" },
];

const WEEKLY_DATA = [
  // { week: "Week 1 (Mar 1–7)", earned: 30, commission: 5, net: 25 },
  // { week: "Week 2 (Mar 8–14)", earned: 50, commission: 8, net: 42 },
  // { week: "Week 3 (Mar 15–21)", earned: 80, commission: 13, net: 67 },
  // { week: "Week 4 (Mar 22–28)", earned: 45, commission: 7, net: 38 },
];

const MONTHLY_DATA = [
  // { month: "January 2026", earned: 120, commission: 20, net: 100 },
  // { month: "February 2026", earned: 150, commission: 30, net: 120 },
  // { month: "March 2026", earned: 270, commission: 50, net: 220 },
];

// ===================== MAIN PAGE =====================
const Earnings = () => {
  const [view, setView] = useState("weekly");// "weekly" | "monthly"
  const [connecting, setConnecting] = useState(false);
  const { baseUrl, token } = useContext(AppContext);
  const navigate = useNavigate();

  const tableData = view === "weekly" ? WEEKLY_DATA : MONTHLY_DATA;
  const labelKey = view === "weekly" ? "week" : "month";
 const handleConnectAccount = async () => {
  try {
    setConnecting(true);

    const response = await axios.post(
      `${baseUrl}/worker/connect-account`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data.success) {
      window.location.href = response.data.url;
    }
  } catch (error) {
    console.log(error.response?.data);

    alert(
      error.response?.data?.message ||
      "Unable to connect Stripe account."
    );
  } finally {
    setConnecting(false);
  }
};
  return (
    <div className="ew-page">

      {/* Header */}
      <div className="ew-page-header">
        <button className="ew-page-header__back" onClick={() => navigate(-1)}>
          <ArrowLeft size={20} />
        </button>
        <div className="ew-page-header__content">
          <h2 className="ew-page-title">Earnings & Wallet</h2>
        </div>
      </div>

      <div className="ew-container">

        {/* ── This Month's Income Card ── */}
       <div className="ew-wallet-card">
  <button
    className="ew-connect-btn"
    onClick={handleConnectAccount}
    disabled={connecting}
  >
    {connecting ? "Connecting..." : "Connect Account"}
  </button>

  <div className="ew-wallet-bg-circle ew-wallet-bg-circle--1" />
  <div className="ew-wallet-bg-circle ew-wallet-bg-circle--2" />

  <div className="ew-wallet-inner">
    <p className="ew-wallet-label">
      <Calendar size={18} className="ew-wallet-label-icon" />
      Payout Account
    </p>

    <h4 className="ew-wallet-amount">
      Connect Your Account
    </h4>

    <p className="ew-wallet-sub">
      Link your payout account with Picks for Tips to receive payments for completed
       jobs.
    </p>
  </div>
</div>

        {/* ── Stats Row ── */}
        {/* <div className="ew-stats-row">
          <div className="ew-stat-card">
            <div className="ew-stat-icon ew-stat-icon--green"><MdTrendingUp /></div>
            <p className="ew-stat-value">$800</p>
            <p className="ew-stat-label">Total Earned</p>
          </div>
          <div className="ew-stat-card">
            <div className="ew-stat-icon ew-stat-icon--red"><MdReceipt /></div>
            <p className="ew-stat-value">$130</p>
            <p className="ew-stat-label">Commission</p>
          </div>
          <div className="ew-stat-card">
            <div className="ew-stat-icon ew-stat-icon--blue"><MdAccountBalanceWallet /></div>
            <p className="ew-stat-value">$670</p>
            <p className="ew-stat-label">Net Earned</p>
          </div>
        </div> */}

        {/* ── Weekly / Monthly Earnings ── */}
        {/* <div className="ew-earnings-section"> */}
          {/* <div className="ew-earnings-header">
            <h5 className="ew-earnings-title">
              <Calendar size={17} className="ew-earnings-title-icon" />
              Earnings Summary
            </h5>
            <div className="ew-view-toggle">
              <button
                className={`ew-toggle-btn ${view === 'weekly' ? 'ew-toggle-btn--active' : ''}`}
                onClick={() => setView('weekly')}
              >
                Weekly
              </button>
              <button
                className={`ew-toggle-btn ${view === 'monthly' ? 'ew-toggle-btn--active' : ''}`}
                onClick={() => setView('monthly')}
              >
                Monthly
              </button>
            </div>
          </div> */}

          {/* <div className="ew-earnings-table"> */}
            {/* Table header */}
            {/* <div className="ew-table-head">
              <span>{view === 'weekly' ? 'Week' : 'Month'}</span>
              <span>Earned</span>
              <span>Commission</span>
              <span>Net</span>
            </div> */}
            {/* Rows */}
            {/* {tableData.map((row, i) => (
              <div key={i} className="ew-table-row">
                <span className="ew-table-period">{row[labelKey]}</span>
                <span className="ew-table-earned">${row.earned.toLocaleString()}</span>
                <span className="ew-table-commission">- ${row.commission.toLocaleString()}</span>
                <span className="ew-table-net">${row.net.toLocaleString()}</span>
              </div>
            ))} */}
          {/* </div> */}
        {/* </div> */}

        {/* ── Recent Transactions ── */}
        {/* <div className="ew-transactions">
          <h5 className="ew-transactions-title">Recent Transactions</h5>
          <div className="ew-txn-list">
            {transactions.map((txn) => (
              <div key={txn.id} className="ew-txn-item">
                <div className={`ew-txn-icon ${txn.type === "credit" ? "ew-txn-icon--credit" : "ew-txn-icon--debit"}`}>
                  {txn.type === "credit" ? <MdArrowUpward /> : <MdArrowDownward />}
                </div>
                <div className="ew-txn-info">
                  <p className="ew-txn-title">{txn.title}</p>
                  <p className="ew-txn-date">{txn.date}</p>
                </div>
                <span className={`ew-txn-amount ${txn.type === "credit" ? "ew-txn-amount--credit" : "ew-txn-amount--debit"}`}>
                  {txn.type === "credit" ? "+" : ""}${Math.abs(txn.amount).toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        </div> */}

      </div>
    </div>
  );
};

export default Earnings;